import {
  ChakraBox,
  ChakraFlex,
  ChakraHeading,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import AdminLogo from '~/assets/svg/AdminLogo';
import EquipLogo from '~/assets/svg/EquipBranding';
import MaudLogo from '~/assets/svg/MaudLogo';
import OpsLogo from '~/assets/svg/OpsLogo';
import { VITE_MAUD_APP_VERSION } from '~/lib/constants/env';
import { UserMode } from '~/lib/contexts/ModeContext';
import usePortalAccess from '~/lib/hooks/usePortalAccess';
import util from '~/lib/util/util';

import OptionCard from './OptionCard';

const { h1, h6 } = EquipUITheme.typography;

const ChoosePortal = () => {
  const { admin, maud, ops } = usePortalAccess();

  return (
    <ChakraFlex
      alignItems="center"
      direction="column"
      justifyContent="space-between"
      minHeight="100vh"
      padding="80px"
    >
      <EquipLogo />
      <ChakraBox>
        <ChakraBox textAlign="center">
          <ChakraHeading {...h1} marginBottom="16px">
            Choose platform
          </ChakraHeading>
          <ChakraText {...h6} color="neutral.secondary" marginBottom="40px">
            Choose the platform where you will be working now.
          </ChakraText>
        </ChakraBox>
        <ChakraFlex>
          {admin && (
            <OptionCard
              id="admin-access"
              logo={<AdminLogo />}
              name="Admin access"
              toMode={UserMode.ADMIN}
            />
          )}
          {maud && (
            <OptionCard
              id="maud-access"
              logo={<MaudLogo />}
              name="Provider access"
              toMode={UserMode.MAUD}
            />
          )}
          {ops && (
            <OptionCard
              id="ops-access"
              logo={<OpsLogo />}
              name="Ops access"
              toMode={UserMode.OPS}
            />
          )}
        </ChakraFlex>
      </ChakraBox>
      <ChakraBox textAlign="center">
        <ChakraHeading as="h4" size="md">
          &copy; Equip, {new Date().getFullYear()}
        </ChakraHeading>
        <ChakraText fontSize="sm">
          Equip is a medical management platform for patients, doctors and
          providers.
        </ChakraText>
        {VITE_MAUD_APP_VERSION ? (
          <ChakraText fontSize="sm">{util.getAppVersion()}</ChakraText>
        ) : null}
      </ChakraBox>
    </ChakraFlex>
  );
};

export default ChoosePortal;
